export function getMimeTypeFromUrl(urlString, allowedImageTypes) {
  const match = urlString.trim().toLowerCase().match(/\.(png|jpe?g|webp)(?:\?|#|$)/)
  if (!match) return undefined

  const extension = match[1]
  if (extension === 'png') {
    return allowedImageTypes.includes('image/png') ? 'image/png' : undefined
  }

  if (extension === 'webp') {
    return allowedImageTypes.includes('image/webp') ? 'image/webp' : undefined
  }

  if (allowedImageTypes.includes('image/jpg')) {
    return 'image/jpg'
  }

  if (allowedImageTypes.includes('image/jpeg')) {
    return 'image/jpeg'
  }

  return undefined
}
